import { render, staticRenderFns } from "./meetingSummary.vue?vue&type=template&id=52ec68a8&scoped=true&"
import script from "./meetingSummary.vue?vue&type=script&lang=js&"
export * from "./meetingSummary.vue?vue&type=script&lang=js&"
import style0 from "./meetingSummary.vue?vue&type=style&index=0&id=52ec68a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ec68a8",
  null
  
)

export default component.exports